<div class="oase-antwort">
  <mat-card appearance="outlined" *ngIf="fragebogen && !gespeichert">
    <mat-card-title class="shorten-long-text">{{ fragebogen.name }}</mat-card-title>
    <mat-card-content>
      <div [innerHTML]="fragebogen.einleitungstext"></div>
    </mat-card-content>
  </mat-card>
  <mat-card appearance="outlined" *ngIf="aktuell && !gespeichert">
    <mat-card-title class="shorten-long-text" *ngIf="!aktuell.gesperrt">{{ aktuell.fragestellung }}</mat-card-title>
    <mat-card-content>
      <div *ngIf="!aktuell.gesperrt">
        <div *ngIf="aktuell.typNumber != 0 && aktuell.typNumber != 3">
          <div *ngFor="let antwort of aktuell.antworten">
            <mat-checkbox [(ngModel)]="antwort.gewaehlt" (change)="checkAnswer(antwort)" color="primary">{{antwort.text}}</mat-checkbox>
          </div>
        </div>
        <div *ngIf="aktuell.typNumber == 3" style="margin-bottom:20px;">

			<mat-form-field>
				<input name="text" matInput [matDatepicker]="textdatepicker"
					   (click)="textdatepicker.open()" (dateChange)="checkAnswer(aktuell.antworten[0])"
					   [(ngModel)]="aktuell.antworten[0].text">
				<mat-hint>{{ OBJ_LNG_NAME+'.datumseingabe' | translate:locale.language }}</mat-hint>
				<mat-datepicker-toggle matSuffix [for]="textdatepicker"></mat-datepicker-toggle>
				<mat-datepicker #textdatepicker></mat-datepicker>
			</mat-form-field>

<!--            <md2-datepicker #text="ngModel" [(ngModel)]="aktuell.antworten[0].text" name="text" (ngModelChange)="checkAnswer(aktuell.antworten[0])"  format="dd.MM.y" >
<mat-label>{{ OBJ_LNG_NAME+'.datumseingabe' | translate:locale.language }}</mat-label></md2-datepicker>-->
        </div>
        <div *ngIf="aktuell.typNumber == 0">
          <mat-form-field class="full-width" *ngIf="aktuell.antworten[0] != null">
              <textarea matInput #text="ngModel" [(ngModel)]="aktuell.antworten[0].text" name="text" (ngModelChange)="checkAnswer(aktuell.antworten[0])"  maxlength="500" required rows="3">
<mat-label>{{ OBJ_LNG_NAME+'.texteingabe' | translate:locale.language }}</mat-label></textarea>
              <mat-hint *ngIf="text.errors && (text.dirty || text.touched) && text.errors.required">{{ 'allgemein.validierung.nichtleer' | translate:locale.language:{ typ: OBJ_LNG_NAME+'.titel' | translate:locale.language } }}</mat-hint>
              <mat-hint *ngIf="text.value" align="end">{{ text.value.length }} / 500</mat-hint>
          </mat-form-field>
        </div>
      </div>
      <button mat-icon-button (click)="navigateAnswer(-1)" [disabled]="index==0"><mat-icon>keyboard_arrow_left</mat-icon></button>
      <button mat-icon-button (click)="navigateAnswer(+1)" *ngIf="index+1!=anzahlFragen" [disabled]="arrow_right_disabled"><mat-icon>keyboard_arrow_right</mat-icon></button>
      <button mat-raised-button id="closeAnswers" *ngIf="index+1==anzahlFragen" (click)="checkLastAnswer()" [disabled]="arrow_right_disabled">{{ 'allgemein.abschliessen' | translate:locale.language }}</button>
      <div>{{ OBJ_LNG_NAME+'.frageIndex' | translate:locale.language:{ index: index+1, anzahl: anzahlFragen } }}</div>
      <div *ngIf="fehlerNachricht != ''" class="accent-font">{{ fehlerNachricht }}</div>
    </mat-card-content>
  </mat-card>

  <mat-card appearance="outlined" *ngIf="gespeichert">
    <mat-card-content>
      <div [innerHTML]="fragebogen.schlusstext"></div>
      <div style="margin-top:20px;">
        <button mat-raised-button [routerLink]="['/protected/frageantwort',fragebogen.id,1]">{{ OBJ_LNG_NAME+'.anzeigen' | translate:locale.language }}</button>
      </div>
    </mat-card-content>
  </mat-card>

  <mat-card appearance="outlined" id="savedAnswers" *ngIf="anzeige === '1'">
    <div class="frageantwortDiv">
      <div *ngIf="data[0] != null">
        <div><strong>{{ OBJ_LNG_NAME+'.fragebogen' | translate:locale.language }}:</strong>&nbsp;{{ data[0].fragebogenName }}</div>
        <div><strong>{{ OBJ_LNG_NAME+'.lieferantennummer' | translate:locale.language }}:</strong>&nbsp;{{ lieferant.liefernummer }}</div>
        <div><strong>{{ OBJ_LNG_NAME+'.name' | translate:locale.language }}:</strong>&nbsp;{{ authService.getUserfullname() }}</div>
        <div><strong>{{ OBJ_LNG_NAME+'.adresse' | translate:locale.language }}:</strong>&nbsp;{{ lieferant.strasse+' '+lieferant.plz+' '+lieferant.ort }}</div>
      </div>
      <div class="frageblock" *ngFor="let frageantwort of data">
        <div *ngIf="!frageantwort.verstecken">
          <h3 class="fragestellung">{{ frageantwort.fragestellung }}</h3>
          <div class="antworten" *ngFor="let antwort of frageantwort.antworten">
              <div *ngIf="frageantwort.typNumber != 0 && frageantwort.typNumber != 3">
                <mat-icon style="float:left;" *ngIf="antwort.gewaehlt == false">check_box_outline_blank</mat-icon>
                <mat-icon style="float:left;" *ngIf="antwort.gewaehlt == true">check_box</mat-icon>
                <div class="antwort_text">{{antwort.text}}</div>
              </div>
              <div *ngIf="frageantwort.typNumber == 0">{{antwort.text}}</div>
              <div *ngIf="frageantwort.typNumber == 3">{{antwort.adate}}</div>
              <!-- <mat-checkbox [(ngModel)]="antwort.gewaehlt" (change)="checkAnswer(antwort)" color="primary" disabled>{{antwort.text}}</mat-checkbox> -->
          </div>
        </div>
      </div>
      <div class="unterschrift">{{ OBJ_LNG_NAME+'.unterschrift' | translate:locale.language }}</div>
    </div>
    <button mat-raised-button class="printButton" (click)="printFragebogen()">{{ 'allgemein.drucken' | translate:locale.language }}</button>
  </mat-card>
</div>
